import {
  getLaboratoryList,
  getLaboratoryById,
  createLaboratory,
  searchMasterList,
  createMaster,
  getMasterById,
  updateMaster,
  deleteMasterById,
  searchTestGroup,
  createTestGroup,
  deleteTestGroup,
  updateTestGroup,
  getTestGroupById,
  createSample,
  copySample,
  searchSample,
  getSampleUlrManager,
  getSampleById,
  assignSample,
  addResult,
  approveResult,
  rejectResult,
  createJobAllotment,
  createTestRequest,
  createJobSheet,
  getReferenceId,
  updateReference,
  createReference,
  getReference,
  searchReference,
  deleteReferenceById,
  generateURLNumber,
  deleteSampleUlr,
  getDepartment,
  getDepartmentById,
  updateDepartment,
  createDepartment,
  deleteDepartmentById,
  updateSample,
  getMyTasks,
  getDashboardStats,
  generateResult,
  multiAssign,
  createResultTemplate,
  duplicateResultTemplate,
  deleteResultTemplate,
  getResultTemplate,
  getResultTemplateById,
  updateResultTemplate,
  searchResultTemplate,
  searchDepartment,
  updateResult,
  getPendingInvoiceSamples,
  generateInvoice,
  getCustomerInvoice,
  getInvoiceById,
  updateCutomerAmount,
  getPriceList,
  createPriceList,
  getPriceListById,
  getParametersList,
  updatePriceList,
  deletePriceList,
  getPriceListByMasterAndCustomer,
  assignMultipleUser,
  getAuditLogs,
} from './LaboratoryService';
export type { IGetLaboratoryById, IAssignSampleData, IAddResultData, IMultiAssign } from './ILaboratoryService';

export const LaboratoryService = {
  getLaboratoryList,
  getLaboratoryById,
  createLaboratory,
  searchMasterList,
  createMaster,
  getMasterById,
  updateMaster,
  deleteMasterById,
  searchTestGroup,
  createTestGroup,
  deleteTestGroup,
  updateTestGroup,
  getTestGroupById,
  createSample,
  copySample,
  searchSample,
  getSampleUlrManager,
  getSampleById,
  assignSample,
  addResult,
  approveResult,
  rejectResult,
  updateResult,
  createJobAllotment,
  createTestRequest,
  createJobSheet,
  createReference,
  updateReference,
  getReferenceId,
  getReference,
  searchReference,
  deleteReferenceById,
  generateURLNumber,
  deleteSampleUlr,
  getDepartment,
  getDepartmentById,
  updateDepartment,
  createDepartment,
  deleteDepartmentById,
  updateSample,
  getMyTasks,
  generateResult,
  multiAssign,
  assignMultipleUser,
  createResultTemplate,
  duplicateResultTemplate,
  deleteResultTemplate,
  getResultTemplate,
  getResultTemplateById,
  updateResultTemplate,
  searchResultTemplate,
  searchDepartment,
  getPendingInvoiceSamples,
  generateInvoice,
  getCustomerInvoice,
  getInvoiceById,
  updateCutomerAmount,
  getPriceList,
  createPriceList,
  deletePriceList,
  getPriceListById,
  updatePriceList,
  getPriceListByMasterAndCustomer,
  getParametersList,
  getAuditLogs,
  getDashboardStats,
};
